module.exports = __webpack_public_path__ + "img/ex11.72ff8a26.jpg";